import { FC, useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { filterOption, FormField, FormSelect } from '../common/form';
import { useSystemClassifierSelectOptions } from '../configuration';
import { DataObjectFormDataType } from './types';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './DataObjectRecipientsFormField.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory(
  'data-object-recipients-form-field',
);
addTranslations(translations);

export const DataObjectRecipientsFormField: FC = () => {
  const { getValues, setValue } = useFormContext<DataObjectFormDataType>();
  const options = useSystemClassifierSelectOptions([
    'REPORT_RECIPIENT',
  ]).REPORT_RECIPIENT;
  const { t } = useTranslation();

  const handleDeselect = useCallback(
    (value: number) => {
      let changed = false;

      const requiredKeys = getValues('requiredKeys')?.map((key) => {
        if (key.recipientIds.includes(value)) {
          changed = true;
          return {
            ...key,
            recipientIds: key.recipientIds.filter((id) => id !== value),
          };
        }
        return key;
      });

      if (changed) {
        setValue('requiredKeys', requiredKeys, {
          shouldDirty: true,
        });
      }
    },
    [getValues, setValue],
  );

  return (
    <FormField label={t('label')} name={'recipientIds'} required>
      <FormSelect
        name={'recipientIds'}
        options={options}
        mode="multiple"
        filterOption={filterOption}
        showSearch
        onDeselect={handleDeselect}
      />
    </FormField>
  );
};
